/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import { useEffect, useRef } from 'react';

import videojs from 'video.js';
import 'videojs-contrib-quality-levels';
import 'videojs-http-source-selector';
import 'videojs-youtube';
import { BASEURL } from '../../config';
// ----------------------------------------------------------------------

export default function VideoPlayerPreview({ video }) {
  const playerRef = useRef(null);

  useEffect(() => {
    if (!playerRef.current) {
      const options = {
        playbackRates: [0.5, 1, 1.5, 2],
        fluid: true,
        fill: true,
        responsive: true,
        controls: true,
        preload: 'auto',
        autoplay: true,
        aspectRatio: "16:9",
        controlBar: {
          remainingTimeDisplay: false,
          currentTimeDisplay: true,
          pictureInPictureToggle: false,
          playbackRateMenuButton: false,
          timeDivider: true,
          durationDisplay: true
        },
        inactivityTimeout: 5,
        plugins: {
          httpSourceSelector:
          {
            default: 'auto'
          }
        },
        html5: {
          vhs: {
            overrideNative: true,
          },
          nativeAudioTracks: false,
          nativeVideoTracks: false
        },
      };

      playerRef.current = videojs("video_1", options);
      videojs.log.level('off');
    }
  }, []);

  useEffect(() => {
    const player = playerRef.current;
    return () => {
      if (player && !player.isDisposed()) {
        player.dispose();
        playerRef.current = null;
      }
    };
  }, [playerRef]);

  useEffect(() => {
    const player = playerRef.current;

    if (video) {
      const { id } = video;

      player.poster(`${BASEURL}/stream/video/${id}/thumbnail/thumb.jpg`);
      player.src({
        src: `${BASEURL}/stream/video/${id}/index.m3u8`,
        type: 'application/x-mpegURL',
      });
    }
  }, [video]);

  return (
    <video id="video_1" className="video-js vjs-theme-city" style={{ marginBottom: 10 }} />
  );
}
